import { render, staticRenderFns } from "./accordionexample.vue?vue&type=template&id=1e4b919c&scoped=true&"
import script from "./accordionexample.vue?vue&type=script&lang=js&"
export * from "./accordionexample.vue?vue&type=script&lang=js&"
import style0 from "./accordionexample.vue?vue&type=style&index=0&id=1e4b919c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b919c",
  null
  
)

export default component.exports